var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-form",
        [
          _c("v-text-field", {
            attrs: {
              label: "Username",
              for: "username_field",
              rules: [_vm.reqRule],
              "data-cy": "splunkusername",
            },
            model: {
              value: _vm.username,
              callback: function ($$v) {
                _vm.username = $$v
              },
              expression: "username",
            },
          }),
          _c("v-text-field", {
            attrs: {
              label: "Password",
              for: "password_field",
              type: "password",
              rules: [_vm.reqRule],
              "data-cy": "splunkpassword",
            },
            model: {
              value: _vm.password,
              callback: function ($$v) {
                _vm.password = $$v
              },
              expression: "password",
            },
          }),
          _c(
            "v-container",
            {
              staticStyle: { margin: "0", padding: "0" },
              attrs: { "grid-list-md": "", "text-xs-center": "" },
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs10: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Hostname",
                          for: "hostname_field",
                          rules: [_vm.reqRule],
                          hint: "https://yourdomain.com:8089",
                          "data-cy": "splunkhostname",
                        },
                        model: {
                          value: _vm.hostname,
                          callback: function ($$v) {
                            _vm.hostname = $$v
                          },
                          expression: "hostname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { xs2: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Index",
                          for: "index_field",
                          rules: [_vm.reqRule],
                          "data-cy": "splunkindex",
                        },
                        model: {
                          value: _vm.index,
                          callback: function ($$v) {
                            _vm.index = $$v
                          },
                          expression: "index",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mx-1" },
        [
          _c(
            "v-btn",
            {
              staticClass: "my-4 mt-4",
              attrs: { color: "primary", "data-cy": "splunkLoginButton" },
              on: { click: _vm.login },
            },
            [_vm._v(" Login ")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              staticClass: "mt-4",
              on: {
                click: function ($event) {
                  return _vm.$emit("show-help")
                },
              },
            },
            [
              _vm._v(" Help "),
              _c("v-icon", { staticClass: "ml-2" }, [
                _vm._v(" mdi-help-circle "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }